import browser from 'webextension-polyfill'

import { isChrome, isManifestV3 } from '@/shared/popup'

export const getCurrentTabUrl = async (): Promise<string | undefined> => {
  const [{ url } = { url: undefined }] =
    isChrome() && isManifestV3()
      ? await chrome.tabs.query({
          active: true,
          currentWindow: true,
        })
      : await browser.tabs.query({
          active: true,
          currentWindow: true,
        })
  return url
}
